import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { browserHistory, Router, Route } from 'react-router'

import App from './App';
import Lobby from './routes/Lobby'

import Routes from './routes'
//import registerServiceWorker from './registerServiceWorker';

import '../node_modules/normalize.css/normalize.css'
import '../node_modules/@blueprintjs/core/dist/blueprint.css'

import io from 'socket.io-client'

import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import cluelessReducer from './reducers/cluelessReducer'

/*const socket = io('http://10.0.0.27:5000')
socket.on('serverupdate', (data) => {
    console.debug('received', data)
})*/

let initialState = {
    //socketio: socket,
    activePlayer: 'player1',
    players: {
        player1: {
            characterName: 'Bob',
            playerName: 'Jamal',
            ip: '192.168.0.1',
            position: [0,0]
        },
        player2: {
            characterName: 'Joe',
            playerName: 'Dev',
            ip: '10.0.0.1',
            position: [2,0]
        },
        player3: {
            characterName: 'Tanya',
            playerName: 'Shefali',
            ip: '172.16.0.1',
            position: [4,2]
        },
        player4: {
            characterName: 'Overlap',
            playerName: 'Overlap',
            ip: '127.0.0.1',
            position: [0,0]
        },
        player5: {
            characterName: 'Hallway Creep',
            playerName: 'Hallway Creep',
            ip: 'bogus',
            position: [1,2]
        }
    }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
let store = createStore(
    cluelessReducer, initialState, composeEnhancers(
        applyMiddleware(thunk),
))

ReactDOM.render(
    <Provider store={store}>
        <Router history={browserHistory}>
            <Route path="/" component={Lobby} />
            <Route path="/game/:id" component={App} />
        </Router>
    </Provider>,
    document.getElementById('root')
)

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js